var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faCalendarAlt, faDownload, faSearch, faTimes, faUndo } from "@fortawesome/pro-regular-svg-icons";
import { faCircle, faFilter, faSearch as faSearchSolid } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TableView from "@yodlee/common-components/dist/components/table-view";
import { ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import { NotificationUtils, TableUtils } from "@yodlee/common-components/dist/utilities";
import { Button, Checkbox, Col, DatePicker, Divider, Icon, Input, message, Radio, Row, Spin, Tooltip } from "antd";
import { saveAs } from "file-saver";
import { cloneDeep } from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Highlighter from "react-highlight-words";
import MediaQuery from "react-responsive";
import { NotificationConfigs } from "../../configurations";
import { DataUtils, NotfUtils } from "../../utilities";
var initialPagination = {
    defaultPageSize: 50,
    defaultCurrent: 1,
    pageSizeOptions: ["50", "100", "200"],
    showSizeChanger: true,
    showQuickJumper: true,
    current: 1,
    pageSize: 50
};
var defaultPreferences = { preferences: { widgets: [] } };
var CONTAINER_TYPE = "widgets", CONTAINER_ID = "notf-maint-list-wdgt", TABLE_ID = "notf-maint-list";
var MaintenanceList = function (_a) {
    var _b, _c;
    var authentication = _a.authentication, suffix = _a.suffix, header = _a.header, hidden = _a.hidden, shouldUpdate = _a.shouldUpdate, didUpdate = _a.didUpdate, onView = _a.onView, onAction = _a.onAction;
    var _d = useState(), systemConfig = _d[0], setSystemConfig = _d[1];
    var _e = useState(initialPagination), pagination = _e[0], setPagination = _e[1];
    var _f = useState(), maintenanceList = _f[0], setMaintenanceList = _f[1];
    // const [userPreferenceData, setUserPreferencData] = useState<Preferences>();
    var _g = useState(), tablePreferenceData = _g[0], setTablePreferenceData = _g[1];
    var _h = useState(), columnMap = _h[0], setColumnMap = _h[1];
    var _j = useState(false), filtersTouched = _j[0], setFiltersTouched = _j[1];
    var _k = useState(false), searching = _k[0], setIsSearching = _k[1];
    var searchFilterRefs = useRef({});
    var searchFilterKeysRef = useRef({});
    var initialMountComplete = useRef(false);
    useEffect(function () {
        if (!initialMountComplete.current)
            return;
        getTableListData(pagination, searchFilterKeysRef.current);
    }, [(_b = authentication.selectedBrand) === null || _b === void 0 ? void 0 : _b.id]);
    useEffect(function () {
        DataUtils.systemConfig(authentication).get().then(function (response) {
            setSystemConfig(response);
        });
        var parsedPrefData = undefined;
        DataUtils.preference(authentication).get().then(function (response) {
            var prefResp = response === null || response === void 0 ? void 0 : response.preference;
            try {
                parsedPrefData = JSON.parse(prefResp || "{}");
            }
            catch (e) { }
        }).finally(function () {
            mapSavedPreferencesToTable(parsedPrefData || __assign({}, defaultPreferences));
        });
        if (!initialMountComplete.current)
            initialMountComplete.current = true;
    }, []);
    useEffect(function () {
        if (!initialMountComplete.current) {
            if (shouldUpdate) {
                didUpdate && didUpdate();
            }
            return;
        }
        if (shouldUpdate) {
            didUpdate && didUpdate();
            getTableListData(pagination, searchFilterKeysRef.current);
        }
    }, [shouldUpdate]);
    var mapSavedPreferencesToTable = function (preferences) {
        var tableFilters = undefined, localColumnMap = undefined;
        var listTable = TableUtils.getRequiredTable(cloneDeep(preferences), CONTAINER_TYPE, CONTAINER_ID, TABLE_ID);
        if (listTable) {
            localColumnMap = TableUtils.columnsToMap(listTable === null || listTable === void 0 ? void 0 : listTable.columns);
            var sortedCol = NotfUtils.sortedColumnDetails(localColumnMap === null || localColumnMap === void 0 ? void 0 : localColumnMap.columnMap);
            tableFilters = __assign(__assign({}, localColumnMap === null || localColumnMap === void 0 ? void 0 : localColumnMap.filteredFields), { sortedBy: sortedCol === null || sortedCol === void 0 ? void 0 : sortedCol.key, sortOrder: sortedCol === null || sortedCol === void 0 ? void 0 : sortedCol.order });
            setColumnMap(localColumnMap === null || localColumnMap === void 0 ? void 0 : localColumnMap.columnMap);
            // setUserPreferencData(preferences);
            setTablePreferenceData(listTable);
            searchFilterKeysRef.current = tableFilters;
        }
        else {
            // setUserPreferencData(preferences);
            setTablePreferenceData({});
        }
        getTableListData(__assign(__assign({}, initialPagination), listTable === null || listTable === void 0 ? void 0 : listTable.pagination), tableFilters);
    };
    var onTablePreferenceChanges = function (preferenceUpdates) {
        DataUtils.preference(authentication).get().then(function (response) {
            var _a;
            var existingUserPref = JSON.parse((response === null || response === void 0 ? void 0 : response.preference) || "{}");
            var formattedWidgets = TableUtils.formatTablePreferences(cloneDeep(existingUserPref), preferenceUpdates, CONTAINER_TYPE, CONTAINER_ID, TABLE_ID);
            var currentPreferences = cloneDeep(existingUserPref) || {};
            if (currentPreferences === null || currentPreferences === void 0 ? void 0 : currentPreferences.preferences)
                currentPreferences.preferences[CONTAINER_TYPE] = formattedWidgets;
            else
                currentPreferences.preferences = (_a = {}, _a[CONTAINER_TYPE] = formattedWidgets, _a);
            var updatedColumnsMap = TableUtils.getUpdatedColumnsMap(columnMap, preferenceUpdates);
            setColumnMap(updatedColumnsMap);
            // setUserPreferencData(currentPreferences);
            DataUtils.preference(authentication).put(currentPreferences);
        });
    };
    var getTableListData = function (pagination, filters) {
        setMaintenanceList(undefined);
        var formattedFilters = NotfUtils.filterFormatter(filters);
        DataUtils.maintenances(authentication).get(__assign({ pageNumber: pagination.current, pageSize: pagination.pageSize }, formattedFilters))
            .then(function (response) {
            setMaintenanceList(cloneDeep((response === null || response === void 0 ? void 0 : response.data) || []));
            setPagination(__assign(__assign({}, pagination), { total: response === null || response === void 0 ? void 0 : response.totalCount }));
        })
            .catch(function () {
            setMaintenanceList([]);
            setPagination(__assign(__assign({}, pagination), { total: 0 }));
        });
    };
    var searchBar = function (type) { return (React.createElement(Input, { disabled: searching, className: type === "COMPACT" ? "ghost-input" : "", autoFocus: type === "COMPACT", style: { width: type === "COMPACT" ? "100%" : undefined, maxWidth: type === "FULL" ? "300px" : undefined }, onPressEnter: function (e) {
            var _a, _b, _c;
            var searchKey = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
            if ((searchKey || "").length > 0) {
                var arrayOfSearchMaintenance = ((_c = (_b = searchKey === null || searchKey === void 0 ? void 0 : searchKey.split(",")) === null || _b === void 0 ? void 0 : _b.filter(function (val) { return val.trim() !== ""; })) === null || _c === void 0 ? void 0 : _c.map(function (val) { return ({ id: val.trim() }); })) || [];
                if (arrayOfSearchMaintenance.length > 0) {
                    setIsSearching(true);
                    var ids_1 = arrayOfSearchMaintenance.map(function (item) { return item.id; });
                    var promises_1 = [];
                    ids_1.forEach(function (item) {
                        promises_1.push(DataUtils.maintenances(authentication).get({ pageNumber: 1, pageSize: 1, id: item }));
                    });
                    Promise.all(promises_1.map(function (p) { return p.catch(function (e) { return e; }); })).then(function (responses) {
                        var maintenances = [];
                        responses.forEach(function (response) {
                            var _a;
                            (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
                                if (ids_1.includes(item === null || item === void 0 ? void 0 : item.id) && !maintenances.map(function (maintenance) { return maintenance.id; }).includes(item === null || item === void 0 ? void 0 : item.id)) {
                                    maintenances.push(item);
                                }
                            });
                        });
                        var notFound = ids_1.filter(function (id) { return !maintenances.map(function (incident) { return incident.id; }).includes(id); });
                        if (notFound.length > 0) {
                            NotificationUtils.warning("No result found for ".concat(notFound.join(", ")), "Please try another search", undefined, undefined, undefined, 2);
                        }
                        onView(maintenances);
                    }).finally(function () {
                        setIsSearching(false);
                    });
                }
            }
        }, suffix: searching ?
            React.createElement(Spin, { size: "small", indicator: React.createElement(Icon, { type: "loading" }) }) :
            React.createElement(React.Fragment, null, type === "COMPACT" &&
                React.createElement(Icon, { onClick: function () { }, className: "color-pink cursor-pointer", component: function () { return React.createElement(FontAwesomeIcon, { icon: faTimes }); } })), prefix: React.createElement(Icon, { className: "color-gray-5", component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearch }); } }), placeholder: "Search by Maintenance ID" })); };
    var onExport = function () {
        var hide = message.loading('Preparing file...', 0);
        var formattedFilters = NotfUtils.filterFormatter(searchFilterKeysRef.current);
        DataUtils.maintenances(authentication).get(__assign(__assign({}, formattedFilters), { view: "export" }), undefined, true).then(function (resp) {
            saveAs(new Blob([resp], { type: "text/csv;charset=utf-8" }), "Export Maintenances - ".concat(moment(new Date()).format("Do MMM, YYYY"), ".csv"));
        }).finally(function () { return hide(); });
    };
    var headerView = function (matches) { return (React.createElement(React.Fragment, null, header &&
        React.createElement(React.Fragment, null,
            React.createElement("span", { className: "margin-left-xs" }, header)))); };
    var suffixView = function (matches) {
        return React.createElement(React.Fragment, null,
            React.createElement(React.Fragment, null, matches ?
                searchBar("FULL") :
                React.createElement(Tooltip, { title: "Search", placement: "bottomLeft" },
                    React.createElement(Button, { type: "link", className: "no-padding no-margin", onClick: function () { } },
                        React.createElement(Icon, { className: "font-size-xl", component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearch }); } })))),
            React.createElement("span", { className: "margin-right-xs" }),
            matches &&
                React.createElement(React.Fragment, null, headerView(matches)),
            suffix &&
                React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "margin-left-xs" }, suffix)));
    };
    var handleSearch = function (selectedKeys, confirm, key) {
        var _a;
        confirm();
        var newFilters = __assign(__assign({}, searchFilterKeysRef.current), (_a = {}, _a[key] = selectedKeys[0], _a));
        searchFilterKeysRef.current = newFilters;
        getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newFilters);
    };
    var handleReset = function (clearFilters, key) {
        clearFilters();
        var newFilters = __assign({}, searchFilterKeysRef.current);
        delete newFilters[key];
        searchFilterKeysRef.current = newFilters;
        getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newFilters);
    };
    var fixedOptionsFilterProps = function (key, filterOptions, singleSelection) { return ({
        filterDropdown: function (_a) {
            var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
            return (React.createElement("div", null,
                React.createElement("div", { className: "padding-xs", style: { maxHeight: 300, overflowY: "auto" } }, singleSelection ?
                    React.createElement(Radio.Group, { onChange: function (e) { return setSelectedKeys([e.target.value]); }, value: selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0] }, (filterOptions || []).map(function (opt) {
                        return React.createElement(React.Fragment, null,
                            React.createElement(Radio, { className: "padding-bottom-xs", key: opt.name, value: opt.id }, opt.name),
                            React.createElement("br", null));
                    }))
                    :
                        React.createElement(Checkbox.Group, { value: selectedKeys, onChange: function (values) {
                                setSelectedKeys(values);
                            } }, (filterOptions || []).map(function (opt) {
                            return React.createElement(React.Fragment, null,
                                React.createElement(Checkbox, { className: "padding-bottom-xs", key: opt.id, value: opt.id }, opt.name),
                                React.createElement("br", null));
                        }))),
                React.createElement(Divider, { type: "horizontal", className: "no-margin" }),
                React.createElement(Row, { className: "padding-xs" },
                    React.createElement(Col, { span: 16 },
                        React.createElement(Button, { type: "link", onClick: function () {
                                var newSearchFilterKeys = __assign({}, searchFilterKeysRef.current);
                                delete newSearchFilterKeys[key];
                                searchFilterKeysRef.current = newSearchFilterKeys;
                                getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newSearchFilterKeys);
                                clearFilters();
                            } },
                            React.createElement(FontAwesomeIcon, { icon: faUndo }),
                            React.createElement("span", { className: "margin-left-xs" }),
                            React.createElement("b", null, "Revert to default"))),
                    React.createElement(Col, { span: 8, style: { textAlign: "right" } },
                        React.createElement(Button, { type: "primary", onClick: function () {
                                var _a;
                                var newSearchFilterKeys = __assign(__assign({}, searchFilterKeysRef.current), (_a = {}, _a[key] = selectedKeys, _a));
                                searchFilterKeysRef.current = newSearchFilterKeys;
                                getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newSearchFilterKeys);
                                confirm();
                            } }, "Apply")))));
        },
        filters: (filterOptions).map(function (option) { return ({ text: option.name, value: option.id.toString() }); }),
        filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
        onClearFilter: function () { return handleReset(function () { }, key); },
    }); };
    var dateFilterProps = function (key, comparator, enableAllDates) {
        if (enableAllDates === void 0) { enableAllDates = false; }
        return ({
            filterDropdown: function (_a) {
                var _b, _c;
                var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                return (React.createElement("div", null,
                    React.createElement("div", { className: "padding-xs" },
                        React.createElement(DatePicker, { value: selectedKeys && (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0]) && moment(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0]) ?
                                moment(comparator === "after" ? (_b = selectedKeys[0]) === null || _b === void 0 ? void 0 : _b.from : (_c = selectedKeys[0]) === null || _c === void 0 ? void 0 : _c.to)
                                : undefined, onChange: function (dateRange) {
                                var _a;
                                var value = dateRange;
                                if (value) {
                                    setSelectedKeys(comparator === "after" ? [{ from: value.startOf("day").valueOf() }] : [{ to: value.endOf("day").valueOf() }]);
                                    var newSearchFilterKeys = __assign(__assign({}, searchFilterKeysRef.current), (_a = {}, _a[key] = comparator === "after" ? [{ from: value.startOf("day").valueOf() }] : [{ to: value.endOf("day").valueOf() }], _a));
                                    searchFilterKeysRef.current = newSearchFilterKeys;
                                }
                                else {
                                    setSelectedKeys(undefined);
                                    var newSearchFilterKeys = __assign({}, searchFilterKeysRef.current);
                                    delete newSearchFilterKeys[key];
                                    searchFilterKeysRef.current = newSearchFilterKeys;
                                }
                            }, style: { marginBottom: 8, display: 'block' }, allowClear: true, disabledDate: function (current) { return !enableAllDates && current && current > moment(new Date()).endOf("day") ? true : false; }, format: "MMMM DD, YYYY", showToday: false, suffixIcon: React.createElement(Icon, { className: "color-gray-5", component: function () { return React.createElement(FontAwesomeIcon, { icon: faCalendarAlt }); } }) })),
                    React.createElement(Divider, { type: "horizontal", className: "no-margin" }),
                    React.createElement(Row, { className: "padding-xs" },
                        React.createElement(Col, { span: 16, style: { textAlign: "right" } },
                            React.createElement(Button, { type: "link", className: "color-blue-5 cursor-pointer", onClick: function () {
                                    clearFilters();
                                    var newSearchFilterKeys = __assign({}, searchFilterKeysRef.current);
                                    delete newSearchFilterKeys[key];
                                    searchFilterKeysRef.current = newSearchFilterKeys;
                                    getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newSearchFilterKeys);
                                } },
                                React.createElement(FontAwesomeIcon, { icon: faUndo }),
                                React.createElement("span", { className: "margin-left-xs" }),
                                React.createElement("b", null, "Revert to default"))),
                        React.createElement(Col, { span: 8, style: { textAlign: "right" } },
                            React.createElement(Button, { type: "primary", className: "cursor-pointer", onClick: function () {
                                    confirm();
                                    getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), searchFilterKeysRef.current);
                                } }, "Apply")))));
            },
            onFilter: function (value, record) { return true; },
            filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
            filterMultiple: false,
            onClearFilter: function () { return handleReset(function () { }, key); },
        });
    };
    var searchFilterProps = function (dataIndex, title, key, getValue, render) {
        if (getValue === void 0) { getValue = function (item) { return (item || "").toString(); }; }
        return ({
            filterDropdown: function (_a) {
                var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                return (React.createElement("div", { className: "padding-xs" },
                    React.createElement(Input, { className: "no-margin no-padding", ref: function (node) {
                            searchFilterRefs.current[key] = node;
                        }, placeholder: "Search by ".concat(title.toLowerCase()), value: selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0], onChange: function (e) {
                            var value = e.target.value;
                            setSelectedKeys(value ? [e.target.value] : []);
                            !value && handleReset(clearFilters, key);
                        }, onPressEnter: function () { return handleSearch(selectedKeys, confirm, key); }, style: { width: 188, marginBottom: 8, display: 'block' }, allowClear: true })));
            },
            filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearchSolid }); } }),
            onFilter: function (value, record) {
                return true;
                // let newValue = get(record, dataIndex, "");
                // if (getValue) {
                //     newValue = getValue(newValue);
                // }
                // return newValue.toString().toLowerCase().includes(value.toLowerCase())
            },
            onFilterDropdownVisibleChange: function (visible) {
                if (visible) {
                    setTimeout(function () { return searchFilterRefs.current[key].select(); });
                }
            },
            onClearFilter: function () { return handleReset(function () { }, key); },
            render: render ? render : function (text) {
                var _a;
                var wordsToHighLight = undefined, currentFilter = (_a = searchFilterKeysRef.current) === null || _a === void 0 ? void 0 : _a[key];
                if (currentFilter)
                    wordsToHighLight = Array.isArray(currentFilter) ? currentFilter : [currentFilter];
                return text && wordsToHighLight ?
                    React.createElement(Highlighter, { highlightStyle: { backgroundColor: 'yellow', padding: 0 }, searchWords: wordsToHighLight, autoEscape: true, textToHighlight: getValue(text) }) :
                    React.createElement(Tooltip, { title: getValue(text), placement: "bottomLeft" }, getValue(text));
            }
        });
    };
    var columns = [
        __assign({ title: "ID", key: "id", dataIndex: "id", width: 150, minWidth: 150, sorter: function () { return 0; }, ellipsis: true }, searchFilterProps("id", "ID", "id", undefined, function (id, record) {
            return React.createElement("span", { onClick: function () { return onView([record]); }, className: "color-blue-5 cursor-pointer" },
                React.createElement(Tooltip, { placement: "bottomLeft", title: id },
                    React.createElement("b", null, id)));
        })),
        __assign(__assign({ title: "Publish status", className: "hidden-tblttl-col", key: "isPublish", dataIndex: "isPublish", width: 50, minWidth: 50, ellipsis: true }, fixedOptionsFilterProps("isPublish", [{ id: "true", name: "Published" }, { id: "false", name: "Draft" }])), { render: function (published) { return published ? React.createElement(FontAwesomeIcon, { color: "#519D2F", style: { fontSize: 12 }, icon: faCircle }) : React.createElement(FontAwesomeIcon, { style: { fontSize: 12 }, className: "color-gray-4", icon: faCircle }); } }),
        __assign({ title: "Title", key: "title", dataIndex: "title", width: 200, minWidth: 200, sorter: function () { return 0; }, ellipsis: true }, searchFilterProps("title", "Title", "title")),
        __assign({ title: "Status", key: "status", dataIndex: "status.name", width: 150, minWidth: 150, sorter: function () { return 0; }, ellipsis: true, render: function (data, record) {
                var _a;
                var statusDetails = NotificationConfigs.maintenanceStatusConfig[(_a = record.status) === null || _a === void 0 ? void 0 : _a.id];
                var colorClassName = (statusDetails === null || statusDetails === void 0 ? void 0 : statusDetails.colorClass) ? "color-" + (statusDetails === null || statusDetails === void 0 ? void 0 : statusDetails.colorClass) : "";
                return React.createElement("div", { style: { width: "fit-content", display: "flex", alignItems: "center" } },
                    (statusDetails === null || statusDetails === void 0 ? void 0 : statusDetails.icon) && React.createElement(FontAwesomeIcon, { spin: statusDetails === null || statusDetails === void 0 ? void 0 : statusDetails.spin, className: "margin-right-xs ".concat(colorClassName), icon: statusDetails === null || statusDetails === void 0 ? void 0 : statusDetails.icon }),
                    React.createElement("div", { style: { fontWeight: (statusDetails === null || statusDetails === void 0 ? void 0 : statusDetails.colorClass) ? "bold" : "normal" }, className: colorClassName }, data));
            } }, fixedOptionsFilterProps("status", ((_c = systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.maintenance) === null || _c === void 0 ? void 0 : _c.status) || [])),
        __assign({ title: "Start", key: "startTime", dataIndex: "startTime", width: 150, minWidth: 150, render: function (data, record) {
                return React.createElement("span", null,
                    React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: data ? moment(data).calendar() : undefined }, data ? moment(data).calendar() : "N/A"));
            }, sorter: function () { return 0; }, ellipsis: true }, dateFilterProps("startTime", "after", true)),
        __assign({ title: "End", key: "endTime", dataIndex: "endTime", width: 150, minWidth: 150, render: function (data, record) {
                return React.createElement("span", null,
                    React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: data ? moment(data).calendar() : undefined }, data ? moment(data).calendar() : "N/A"));
            }, sorter: function () { return 0; }, ellipsis: true }, dateFilterProps("endTime", "before", true)),
        {
            title: "Created by",
            key: "createdBy",
            dataIndex: "createdBy.userName",
            width: 150,
            minWidth: 150,
            ellipsis: true,
        },
        {
            title: "Updated",
            key: "updated",
            dataIndex: "updated",
            width: 150,
            minWidth: 150,
            render: function (data, record) {
                return React.createElement("span", null,
                    React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: data ? moment(data).calendar() : undefined }, data ? moment(data).calendar() : "N/A"));
            },
            sorter: function () { return 0; },
            ellipsis: true,
        },
        __assign({ title: "Ticket", key: "changeRequest", dataIndex: "changeRequest", width: 150, minWidth: 150, sorter: function () { return 0; }, ellipsis: true }, searchFilterProps("changeRequest", "Ticket", "changeRequest")),
    ];
    var quickActions = [{
            name: "Edit",
            key: "edit",
            onClick: function (records) {
                onView(records);
            }
        }
    ];
    var formattedColumns = NotfUtils.formatColumns(columns, columnMap, undefined, filtersTouched);
    return React.createElement(MediaQuery, { minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD }, function (matches) {
        var _a;
        return systemConfig && tablePreferenceData ? React.createElement(React.Fragment, null,
            React.createElement(TableView, { showClearFilter: true, onClearAllFilter: function () {
                    var sortFilters = { sortedBy: searchFilterKeysRef === null || searchFilterKeysRef === void 0 ? void 0 : searchFilterKeysRef.current["sortedBy"], sortOrder: searchFilterKeysRef === null || searchFilterKeysRef === void 0 ? void 0 : searchFilterKeysRef.current["sortOrder"] };
                    searchFilterKeysRef.current = sortFilters;
                    getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), sortFilters);
                }, locale: { emptyText: "We can't find any maintenances." }, suffix: suffixView(matches), 
                // prefix={prefix}
                extra: React.createElement(React.Fragment, null,
                    React.createElement(Button, { type: "link", onClick: function () { return onExport(); } },
                        React.createElement(Icon, { className: "font-size-lg", component: function () { return React.createElement(FontAwesomeIcon, { icon: faDownload }); } }),
                        React.createElement("span", { className: "margin-left-xs" }),
                        "Export")), 
                // header={headerView(matches)}
                // footer={footer}
                // name={LabelConfigs.SERVICE_REQUEST}
                onRowSelect: function (ids) {
                }, quickActions: quickActions, fixedColumns: ["id", "isPublish"], data: hidden ? [] : (maintenanceList || []), loading: !maintenanceList, getRowKey: function (data) { var _a; return (_a = data === null || data === void 0 ? void 0 : data.id) === null || _a === void 0 ? void 0 : _a.toString(); }, rowDensity: tablePreferenceData === null || tablePreferenceData === void 0 ? void 0 : tablePreferenceData.density, columns: formattedColumns === null || formattedColumns === void 0 ? void 0 : formattedColumns.allColumns, selectedColumnKeys: ((_a = formattedColumns === null || formattedColumns === void 0 ? void 0 : formattedColumns.visibleColumns) === null || _a === void 0 ? void 0 : _a.length) > 0 ? formattedColumns === null || formattedColumns === void 0 ? void 0 : formattedColumns.visibleColumns : undefined, defaultColumnKeys: ["id", "title", "status", "alertType"], onPreferenceChanges: function (preference) { return onTablePreferenceChanges(__assign(__assign({}, preference), { pagination: __assign(__assign({}, preference.pagination), { pageSize: 50 }) })); }, 
                // onDensityChange={(size) => AmplitudeEventsUtils.srListCustomize('CHANGE DENSITY', size)}
                // onOrderChange={(column, initialPosition, newPosition) => AmplitudeEventsUtils.srListCustomize('CHANGE COLUMN ORDER', { column, initialPosition, newPosition })}
                // onToggle={(action, key) => AmplitudeEventsUtils.srListCustomize(action === 'Add' ? 'ADD COLUMN' : 'REMOVE COLUMN', key)}
                // onResize={(column, width) => AmplitudeEventsUtils.srListCustomize('CHANGE COLUMN WIDTH', { column, width })}
                // onExport={() => onExport()}
                pagination: pagination, onChange: function (newPagination, filters, sorter) {
                    var _a, _b;
                    if (!filtersTouched)
                        setFiltersTouched(true);
                    var hasSortOrderChanged = (searchFilterKeysRef === null || searchFilterKeysRef === void 0 ? void 0 : searchFilterKeysRef.current["sortedBy"]) !== ((_a = sorter === null || sorter === void 0 ? void 0 : sorter.column) === null || _a === void 0 ? void 0 : _a.key) || (searchFilterKeysRef === null || searchFilterKeysRef === void 0 ? void 0 : searchFilterKeysRef.current["sortOrder"]) !== (sorter === null || sorter === void 0 ? void 0 : sorter.order);
                    var newFilters = __assign({}, searchFilterKeysRef.current);
                    if (hasSortOrderChanged) {
                        newFilters = __assign(__assign({}, newFilters), { sortedBy: (_b = sorter === null || sorter === void 0 ? void 0 : sorter.column) === null || _b === void 0 ? void 0 : _b.key, sortOrder: sorter === null || sorter === void 0 ? void 0 : sorter.order });
                        searchFilterKeysRef.current = newFilters;
                    }
                    if (hasSortOrderChanged || (newPagination && (newPagination.current !== pagination.current || newPagination.pageSize !== pagination.pageSize))) {
                        getTableListData(__assign(__assign({}, pagination), newPagination), newFilters);
                    }
                } }))
            :
                React.createElement(Row, { type: "flex", justify: "center", align: "middle", style: { height: "80vh" } },
                    React.createElement(Col, null,
                        React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) })));
    });
};
export default MaintenanceList;
//# sourceMappingURL=index.js.map